<template>
	<div v-if="question">
	<div class="container container--narrow pdt-50">
		<question-tag
			:correctRate="question.avgSolveTime"
			:avgSolveTime="question.avgSolveTime"
			:level="paperLevel"
		></question-tag>
			<div v-if="groupQuestionCount === 1">
				<!-- {{question.contents.text}} -->
				<div v-for="(node, n) in nodes" :key="n">
					<answer-type v-if="n % 2" 
						:data="question.blank.items[node]"
						:itemIndex="node"
						:setedAnswer="question.blank.items[node].reply"
					></answer-type>
					<div class="mgt-24 t-subtitle6 t-line-h-28 font-rn" v-else>{{node}}</div>
				</div>
				<div class="mgt-16" v-if="question && question.contents && question.contents.image">
					<img :src="question.contents.image" alt="" class="b-radius4 ">
				</div>    
				<div>
					<div class="divider mgt-16 mgb-16"></div>
						<div class="mgt-24 t-subtitle3 font-rn">
							{{isCorrect() ? $t('1270') : $t('1271')}}
						</div>
						<div class="bg-quizGray b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 mgt-24  box-54">
							<div class="d-flex align-items-center">
								<div class="t-body6 t-color-quizBlack font-r flex-grow-1">
									<span v-for="(node, n) in nodesCorrect" :key="n" :class="{'correct': n % 2 && question.correct, 'incorrect': n % 2 && !question.correct}">
											{{n % 2 ? `[${node}]` : node}}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
		<div v-else>
			<div class="mgt-16 t-body1 t-line-h-28 ">
				{{groupQuestionTitle}}
			</div>
			<div class="mgt-24">
				<div class="mdc-card pda-24 bg-documentGray position-relative grouped-card">
							<div v-for="(node, n) in nodes" :key="n">
								<answer-type v-if="n % 2" 
									:data="question.blank.items[node]"
									:itemIndex="node"
									:setedAnswer="question.blank.items[node].reply"
								></answer-type>
								<div class="mgt-24 t-subtitle6 t-line-h-28 font-rn" v-else>{{node}}</div>
							</div>
							<div class="mgt-16" v-if="question && question.contents && question.contents.image">
								<img :src="question.contents.image" alt="" class="b-radius4">
							</div>
						<div>
						<div class="divider mgt-16 mgb-16"></div>
							<div class="mgt-24 t-subtitle3 font-rn">
								{{isCorrect() ? $t('1270') : $t('1271')}}
							</div>
							<div class="bg-quizGray b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 mgt-24  box-54">
								<div class="d-flex align-items-center">
									<div class="t-body6 t-color-quizBlack font-r flex-grow-1">
										<span v-for="(node, n) in nodesCorrect" :key="n" :class="{'correct': n % 2 && question.correct, 'incorrect': n % 2 && !question.correct}">
												{{n % 2 ? `[${node}]` : node}}
										</span>
									</div>
								</div>
							</div>
						</div>
						</div>
					</div>
				</div>
			<question-tip v-if="question && question.tip" :tip="question.tip" :marginType="groupQuestionCount === 1 ? true :false"/>
		</div>
	<question-feedback
		:commonFeedback="question.feedback.common"
		:correctFeedback="question.feedback.correct"
		:incorrectFeedback="question.feedback.incorrect"
		:videoFeedback="question.feedback.video"
		:feedbackStatus="feedback"
		:correct="question.correct"
		:questionId="question.questionId"
		:currentGroupIndex="currentGroupIndex"
	></question-feedback>
</div>


</template>

<script>
/**
 * 응답내장형 문항 피드백 컴포넌트(fill in the blank type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import QuestionFeedback from './QuestionFeedback.vue'
import {questionMixin} from '@/mixins/question.js'
import AnswerType from './AnswerTypeFeedback.vue'


export default {
		props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'paperLevel', 'feedback', 'currentGroupIndex'],
		data() {
			return {
				texts: '',
				parsedQuestionTitle: '',
				parsedQuestionCorrect: '',
			}
		},
		components: {
			'question-tag': QuestionTag,
			'question-tip': QuestionTip,
			'answer-type': AnswerType,
			'question-feedback': QuestionFeedback
		},

    mixins: [questionMixin],

	watch: {
        question (newVar, oldVar) {
            // console.log('setedAnswer=>newVar',newVar)
            // console.log('setedAnswer=>oldVar',oldVar)
            this.parsedQuestionCorrect = JSON.parse(JSON.stringify(this.question.contents.text))
        }
    },

    mounted() {
					this.texts = ''
					this.parsedQuestionTitle = this.question.blank.contents
					this.parsedQuestionCorrect = this.question.contents.text
					//console.log('question', this.question);
					let msg = this.parsedQuestionCorrect
					let patten=/\[.+?\]/g   
    },

    
    computed: {
        // 응답 내장형 문항 답안 파싱(parse question answer)
        nodes() {
            return this.parsedQuestionTitle.split(/\{([0-9]+)\}/g)
        },

        // 응답 내장형 문항 정답 파싱(parse question correct)
        nodesCorrect() {
            return this.parsedQuestionCorrect.split(/\[(.*?)\]/g)
        }
    },
}
</script>
<style scoped>
.question-choices .choice .correct-icon {
    min-width: 32px;
    height: 32px;}
    .gry-color{color:var(BodyGrayA);}
</style>